import React, { useContext, useRef, useState } from "react";
import {
  Box,
  Typography,
  Button,
  Paper,
  Divider,
  CircularProgress,
  Avatar,
  Tabs,
  Tab,
  Grid2
} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

import LoggedInLayout from "../../layout/LoggedInLayout";
import StudentProfileUpdate from "../Council/StudentProfileUpdate";
import AuthContext from "../../context/AuthContext";
import httpcommon from "../../helper/httpcommon";
import ParentAccessSection from "./ParentAccessSection";

import BackdropImage from "/assets/newImages/Backdrop.png";

/* ------------------ STYLES ------------------ */
const style = {
  pageWrapper: {
    backgroundColor: "#F4F6F8",
    minHeight: "100vh",
    padding: "32px",
  },

  title: {
    fontWeight: 500,
    fontSize: "32px",
    marginBottom: "24px",
  },

  paper: {
    backgroundColor: "#ffffff",
    boxShadow: "0 8px 24px rgba(0,0,0,0.06)",
  },

  banner: {
    height: "200px",
    backgroundImage: `url(${BackdropImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    position: "relative",
  },

  avatarWrapper: {
    width: "120px",
    height: "120px",
    position: "absolute",
    bottom: "-50px",
    left: "50px",
    zIndex: 8,
  },

  avatar: {
    width: "120px !important",
    height: "120px !important",
    borderRadius: "10px !important",
    border: "4px solid white",
    boxShadow: "0 6px 18px rgba(0,0,0,0.2)",
    cursor: "pointer",
  },

  content: {
    padding: "0 48px 10px 48px",
  },

  nameSection: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "80px",
  },

  userName: {
    fontSize: "26px",
    fontWeight: 600,
    color: "#000",
    fontFamily: "Segoe UI",

  },

  email: {
    fontSize: "18px",
    color: "rgba(22, 20, 20, 0.6)",
    lineHeight: "150%",
    fontWeight: 400,

    fontFamily: "Segoe UI",
  },

  editButton: {
    textTransform: "none !important",
    borderRadius: "10px !important",
    padding: "0 32px !important",
    height: "44px",
    fontWeight: 500,
    background:
      "linear-gradient(180deg, #DB9131 0%, #F7AA47 129.82%) !important",
    boxShadow:
      "0 11px 11px 0 rgba(0, 0, 0, 0.09), 0 3px 6px 0 rgba(0, 0, 0, 0.10)",
  },



  tab: {
    textTransform: "none !important",
    fontSize: "14px !important",
    fontWeight: "700 !important",
    minWidth: "200px !important",
  },

  infoRow: {
    marginBottom: "26px",
  },

  label: {
    fontSize: "15px",
    color: "#231F20",
    fontWeight: 400,
  },

  value: {
    fontSize: "15px",
    fontWeight: 600,
    color: "#231F20",
  },
  tabcontent: {
    padding: "42px 24px",
    borderRadius: "0 0 10px 10px",
    backgroundColor: "#EBEBEB"
  },
};

/* ---------- Info Row ---------- */
const InfoRow = ({ label, value }) => {
  return (
    <Grid2 container sx={style.infoRow}>
      <Grid2 size={{ xs: 3, md: 3 }}>
        <Typography sx={style.label}>{label}</Typography>
      </Grid2>
      <Grid2 size={{ xs: 1, md: 1 }}>
        <Typography sx={style.label}>:</Typography>
      </Grid2>
      <Grid2 size={{ xs: 6, md: 7 }}>
        <Typography sx={style.value}>{value || "-"}</Typography>
      </Grid2>
    </Grid2>
  );
};

const Profile = () => {
  const { user, refetchUser } = useContext(AuthContext);
  const student = user?.userInfo;
  const isParentPortal = user?.role === "Parent";

  const [openUpdateModel, setOpenUpdateModel] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const fileInputRef = useRef(null);

  const toBase64 = (file) =>
    new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => resolve(reader.result.split(",")[1]);
      reader.onerror = reject;
    });

  const handleProfileUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const base64 = await toBase64(file);
    await httpcommon.post("school/student/avatar/", {
      avatar_base64: base64,
    });
    await refetchUser();
  };

  return (
    <LoggedInLayout searchBar={false}>
      <Box sx={style.pageWrapper}>
        <Typography  sx={style.title}>
          Profile
        </Typography>
        <Box>


          <Paper elevation={0} sx={style.paper}>
            {!student ? (
              <Box display="flex" justifyContent="center" py={6}>
                <CircularProgress />
              </Box>
            ) : (
              <>
                {/* Banner */}
                <Box sx={style.banner}>
                  <Box sx={style.avatarWrapper}>
                    <Avatar
                      src={student?.avatar}
                      sx={style.avatar}
                      onClick={() => fileInputRef.current.click()}
                    />
                    <input
                      ref={fileInputRef}
                      hidden
                      type="file"
                      accept="image/*"
                      onChange={handleProfileUpload}
                    />
                  </Box>
                </Box>

                {/* Content */}
                <Box sx={style.content}>
                  <Box sx={style.nameSection}>
                    <Box>
                      <Typography sx={style.userName}>
                        {student?.user_name}
                      </Typography>
                      <Typography sx={style.email}>
                        {student?.user_email}
                      </Typography>
                    </Box>

                    <Button
                      variant="contained"
                      endIcon={<EditOutlinedIcon />}
                      sx={style.editButton}
                      onClick={() => setOpenUpdateModel(true)}
                    >
                      Edit / Update
                    </Button>
                  </Box>
                </Box>

                <Divider sx={{ my: 1 }} />

                <Tabs
                  value={tabValue}
                  onChange={(e, v) => setTabValue(v)}
                  TabIndicatorProps={{
                    style: { backgroundColor: "#F4A041", height: 3 },
                  }}
                >
                  <Tab label="Personal Information" sx={style.tab} />
                  <Tab label={isParentPortal ? "Children Access" : "Parent Access"} sx={style.tab} />
                </Tabs>


              </>
            )}
          </Paper>
          <Box sx={style.tabcontent}>
            {tabValue === 0 && (
              <Box
                display="flex"
                justifyContent="space-evenly"
                gap={6}
                flexWrap="wrap"
              >
                <Box flex={1} minWidth={300}>
                  <InfoRow label="Name" value={student?.user_name} />
                  <InfoRow label="E-mail" value={student?.user_email} />
                  <InfoRow label="Date of Birth" value={student?.birth_date} />
                  <InfoRow label="Contact No." value={student?.contact_number} />
                </Box>

                <Box flex={1} minWidth={300}>
                  <InfoRow label="School Name" value={student?.school} />
                  <InfoRow label="Board" value={student?.board} />
                  <InfoRow label="Class" value={student?.student_class} />
                  <InfoRow label="Address" value={student?.address} />
                </Box>
              </Box>
            )}

            {tabValue === 1 && (
              <ParentAccessSection mode={isParentPortal ? "parent" : "student"} />
            )}
          </Box>
        </Box>
        <StudentProfileUpdate
          open={openUpdateModel}
          onClose={async () => {
            setOpenUpdateModel(false);
            await refetchUser();
          }}
        />
      </Box>
    </LoggedInLayout>
  );
};

export default Profile;
